// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../../reason/next/Next.bs.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var GeocodingQuery = require("../propertyForms/Geocoding/GeocodingQuery.bs.js");
var MlsStatusQuery = require("../propertyForms/Geocoding/MlsStatusQuery.bs.js");
var Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelayEffects_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayEffects_formState_graphql.bs.js");
var PropertyWizardFormRelayEffects_localDraft_graphql = require("../../../__generated__/PropertyWizardFormRelayEffects_localDraft_graphql.bs.js");

var convertFragment = PropertyWizardFormRelayEffects_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, fRef);
}

var LocalDraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelayEffects_localDraft_graphql.Utils.localDraftPropertyType_decode;

var LocalDraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelayEffects_localDraft_graphql.Utils.localDraftPropertyType_fromString;

var LocalDraftFragment = {
  localDraftPropertyType_decode: LocalDraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: LocalDraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardFormRelayEffects_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftGeocodingStatus_decode;

var FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

var FormStateFragment_localDraftMlsStatus_decode = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftMlsStatus_decode;

var FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftMlsStatus_fromString;

var FormStateFragment = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function use$2(draft, formState, setDuplicatedProperty) {
  var match = PropertyWizardFormRelay.Context.use();
  var mode = match.mode;
  var match$1 = PropertyWizardRelayUtils.QueryParams.use();
  var setQueryParams = match$1[1];
  var queryParams = match$1[0];
  var geocodingTriggeredAt = React.useRef(Date.now());
  var mlsStatusTriggeredAt = React.useRef(Date.now());
  var doMlsStatusCheck = PropertyWizardRelayUtils.useMlsStatusCheck();
  var draft$1 = use(draft);
  var formState$1 = use$1(formState);
  var updateFormState = PropertyWizardFormRelay.FormState.useUpdater();
  var updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  var selectedAreaId = Core__Option.map(draft$1.draftProperty.selectedArea, (function (area) {
          return area.id;
        }));
  React.useEffect((function () {
          var run = async function () {
            var match = formState$1.geocodingStatus;
            var match$1 = draft$1.draftProperty.addressToGeocode;
            if (match === "Called") {
              return ;
            }
            if (selectedAreaId === undefined) {
              return ;
            }
            if (match$1 === undefined) {
              return ;
            }
            if (match$1.trim() === "") {
              return ;
            }
            var triggeredAt = Date.now();
            geocodingTriggeredAt.current = triggeredAt;
            var match$2 = draft$1.draftProperty.propertyType;
            var clientType;
            clientType = match$2 === "FOR_SALE" ? "SELLER" : "LANDLORD";
            updateFormState(function (formState) {
                  formState.geocodingStatus = "Called";
                });
            var tmp;
            if (typeof mode !== "object") {
              tmp = undefined;
            } else {
              switch (mode.TAG) {
                case "Edit" :
                    tmp = mode.id;
                    break;
                case "Rebroadcast" :
                case "BroadcastQuietSeller" :
                    tmp = mode._0;
                    break;
                
              }
            }
            var res = await Utils__Promise.toJsPromise(GeocodingQuery.queryFn(match$1, selectedAreaId, clientType, tmp));
            if (triggeredAt !== geocodingTriggeredAt.current) {
              return ;
            }
            setDuplicatedProperty(function (param) {
                  if (typeof res === "object" && res.NAME === "DuplicatePropertyError") {
                    return Caml_option.some(res.VAL.fragmentRefs);
                  }
                  
                });
            var variant = res.NAME;
            if (variant !== "PropertyAddressValidated") {
              if (variant === "GeocodingError") {
                if (res.VAL === "OutsideChapterBoundaries") {
                  updateDraftProperty(function (localDraftProperty) {
                        var newrecord = Caml_obj.obj_dup(localDraftProperty);
                        newrecord.geocodingData = undefined;
                        return newrecord;
                      });
                  return updateFormState(function (formState) {
                              formState.geocodingStatus = "ErrorOutsideChapterBoundaries";
                            });
                } else {
                  updateDraftProperty(function (localDraftProperty) {
                        var newrecord = Caml_obj.obj_dup(localDraftProperty);
                        newrecord.geocodingData = undefined;
                        return newrecord;
                      });
                  return updateFormState(function (formState) {
                              formState.geocodingStatus = "Error";
                            });
                }
              } else {
                updateDraftProperty(function (localDraftProperty) {
                      var newrecord = Caml_obj.obj_dup(localDraftProperty);
                      newrecord.geocodingData = undefined;
                      return newrecord;
                    });
                return updateFormState(function (formState) {
                            formState.geocodingStatus = "ErrorDuplicateListing";
                          });
              }
            }
            var match$3 = res.VAL;
            var standardizedAddress = match$3.standardizedAddress;
            var coordinates = match$3.coordinates;
            var displayNeighborhoods = match$3.displayNeighborhoods;
            updateDraftProperty(function (localDraftProperty) {
                  var newrecord = Caml_obj.obj_dup(localDraftProperty);
                  newrecord.geocodingData = coordinates !== undefined && standardizedAddress !== undefined ? ({
                        lat: coordinates.lat,
                        lon: coordinates.lon,
                        standardizedAddress: standardizedAddress.address,
                        standardizedCity: standardizedAddress.city,
                        standardizedState: standardizedAddress.state,
                        standardizedZip: standardizedAddress.zip
                      }) : undefined;
                  return newrecord;
                });
            return updateFormState(function (formState) {
                        PropertyWizardFormRelay.FormState.setDisplayNeighborhoods(formState, displayNeighborhoods.map(function (dn) {
                                  return {
                                          __id: dn.__id,
                                          __typename: dn.__typename
                                        };
                                }));
                        formState.geocodingStatus = "Valid";
                      });
          };
          run();
        }), [
        draft$1.draftProperty.addressToGeocode,
        selectedAreaId,
        mode,
        draft$1.draftProperty.propertyType
      ]);
  React.useEffect((function () {
          if (doMlsStatusCheck) {
            var run = async function () {
              var match = formState$1.mlsStatus;
              var match$1 = draft$1.draftProperty.addressToGeocode;
              if (match === "Called") {
                return ;
              }
              if (selectedAreaId === undefined) {
                return ;
              }
              if (match$1 === undefined) {
                return ;
              }
              if (match$1.trim() === "") {
                return ;
              }
              var triggeredAt = Date.now();
              mlsStatusTriggeredAt.current = triggeredAt;
              updateFormState(function (formState) {
                    formState.mlsStatus = "Called";
                  });
              var res = await MlsStatusQuery.queryFn(match$1, selectedAreaId);
              if (triggeredAt !== mlsStatusTriggeredAt.current) {
                return ;
              }
              if (res.TAG !== "Ok") {
                return updateFormState(function (formState) {
                            formState.mlsStatus = "Error";
                          });
              }
              var mlsStatus;
              switch (res._0.__typename) {
                case "PropertyMlsStatusNotOnMls" :
                    mlsStatus = "NotOnMls";
                    break;
                case "PropertyMlsStatusOnMls" :
                    mlsStatus = "OnMls";
                    break;
                case "PropertyMlsStatusOnMlsButAllowed" :
                    mlsStatus = "OnMlsButAllowed";
                    break;
                case "__unselected" :
                    mlsStatus = "Error";
                    break;
                
              }
              return updateFormState(function (formState) {
                          formState.mlsStatus = mlsStatus;
                        });
            };
            run();
          } else {
            updateFormState(function (formState) {
                  formState.mlsStatus = "NotOnMls";
                });
          }
        }), [
        draft$1.draftProperty.addressToGeocode,
        selectedAreaId,
        mode,
        draft$1.draftProperty.propertyType,
        doMlsStatusCheck
      ]);
  React.useEffect((function () {
          var match = queryParams.draftId;
          var match$1 = draft$1.serverDraftId;
          if (match !== undefined) {
            if (match$1 !== undefined) {
              if (match !== match$1) {
                setQueryParams("replaceIn", {
                      draftId: match$1
                    });
              }
              
            } else {
              setQueryParams("replaceIn", {
                    draftId: undefined
                  });
            }
          } else if (match$1 !== undefined) {
            setQueryParams("replaceIn", {
                  draftId: match$1
                });
          }
          
        }), [
        queryParams.draftId,
        draft$1.serverDraftId
      ]);
  var router = Next.useRouter();
  React.useEffect((function () {
          Next.Router.prefetch("/my_clients/[id]", router);
        }), []);
}

var QueryParams;

var Form;

var Validators;

var KeyFactsValidators;

exports.QueryParams = QueryParams;
exports.Form = Form;
exports.LocalDraftFragment = LocalDraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.Validators = Validators;
exports.KeyFactsValidators = KeyFactsValidators;
exports.use = use$2;
/* Next Not a pure module */
